import { get, post, put, _delete } from '../actions/method';
import moment from 'moment';
import { cloneDeep } from 'lodash';

function convertInt(p) {
  let val = parseInt(p);
  return Number.isNaN(val) ? -1 : val;
}
export async function getUserWidgets() {
  return await get('app/widgets/currentUser');
}

export async function getWidgetTypes() {
  return await get('app/widgets/widgetTypes');
}

export async function createUserWidgets(values) {
  const _values = cloneDeep(values);
  _values['width'] = convertInt(_values['width']);
  if (_values.extraProperties.hasOwnProperty('alarms')) {
    if (_values.extraProperties.alarms.length) {
      _values.extraProperties.alarms = JSON.stringify(
        _values.extraProperties.alarms,
      );
    } else _values.extraProperties.alarms = '';
  }
  let params = {
    body: _values,
  };
  return await post(`app/widgets`, params);
}

export async function updateUserWidgets(values) {
  const _values = cloneDeep(values);
  _values['width'] = convertInt(_values['width']);
  if (_values.extraProperties.hasOwnProperty('alarms')) {
    if (_values.extraProperties.alarms.length) {
      _values.extraProperties.alarms = JSON.stringify(
        _values.extraProperties.alarms,
      );
    } else _values.extraProperties.alarms = '';
  }
  let params = {
    body: _values,
  };
  return await put(`app/widgets/${values.id}`, params);
}

export async function deleteUserWidgets(id) {
  return await _delete(`app/widgets/${id}`);
}
